import api from "../axios_service";

export default {
  async getComponentes(userId) {
    const response = await api.get(`/usuarios/${userId}/componentes`);
    return response.data.componentes;
  }
};